import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import { pickBy } from 'lodash';

import { useReports } from '../..';

import SortIconString from '../../../../../components/Table/SortIconString';

const TableHead = () => {
  const history = useHistory();
  const location = useLocation();

  const { filters } = useReports();

  const [sort, setSort] = useState(filters.sort);

  const queryString = qs.parse(location.search.slice(1));

  const onChangeSort = (key) => {
    let sortKey = '';
    if (sort === `${key}-desc`) {
      sortKey = `${key}-asc`;
    } else {
      sortKey = `${key}-desc`
    }

    setSort(sortKey);

    const { page, stack, ...newQuery } = queryString;

    history.push({
      pathname: location.pathname,
      search: qs.stringify(pickBy({ ...newQuery, sort: sortKey })),
    });
  }

  useEffect(() => {
    if (queryString.hasOwnProperty('sort') && queryString?.sort !== sort) {
      setSort(queryString.sort);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString.sort])

  return (
    <thead>
      <tr>
        <th>Username</th>
        <th>
          <button
            onClick={() => onChangeSort('orders')}
            className="btn-sort"
          >
            Orders
            {' '}
            <SortIconString
              name="orders"
              activeSort={sort}
            />
          </button>
        </th>
        <th>
          <button
            onClick={() => onChangeSort('spent')}
            className="btn-sort"
          >
            Spent
            {' '}
            <SortIconString
              name="spent"
              activeSort={sort}
            />
          </button>
        </th>
        <th>
          <button
            onClick={() => onChangeSort('profit')}
            className="btn-sort"
          >
            Profit
            {' '}
            <SortIconString
              name="profit"
              activeSort={sort}
            />
          </button>
        </th>
        <th>
          <button
            onClick={() => onChangeSort('last_order_date')}
            className="btn-sort"
          >
            Last order date
            {' '}
            <SortIconString
              name="last_order_date"
              activeSort={sort}
            />
          </button>
        </th>
      </tr>
    </thead>
  );
};

export default TableHead;
